<div class="sku-qty-cell" [ngClass]="{'ShowSuggestionOnly': params.isShowSuggestionOnly}">
<input
  type="number"
  tabindex="2"
  min="0"
  class="sg_sg-input"
  [formControl]="amount"
  (focusout)="valueChange($event)"
  [myautofocus]="
      params.node.rowIndex === gridActionsService.subGridCellFocusedIndex
    "
  *ngIf="!params.isShowSuggestionOnly"
/>

<div
  class="suggestion"
  *ngIf="params.isShowSuggestionOnly"
>
  SGG QTY: {{ params.data.Suggested | number }}
</div>

<span class="sg_times">
  x
</span>

<input
  type="text"
  [disabled]="true"
  [value]="params.data.Qty"
  class="sg_qty"
/>

<div
  class="sg_count"
  [ngClass]="{
    'sg_count--added': params.data.Suggested === amount.value,
    'sg_count--negetive': params.data.Suggested <= 0,
    'sg_count--neutral': params.data.Suggested === 0
  }"
  (click)="selectSuggestedAmount($event, params.data.Suggested)"
  *ngIf="!params.isShowSuggestionOnly"
>
  SGG QTY: {{ params.data.Suggested | number }}
</div>

</div>